import { alpha, Box, Paper } from "@mui/material";
import type { ReactNode } from "react";
import {
  HIGHLIGHT_FLASH_ALPHA,
  RESULT_SURFACE_BORDER,
} from "src-next/modules/clinical-insights/constants/clinicalInsightsTheme";
import { InsightPanelScrollBox } from "./InsightPanelScrollBox";

interface InsightWorkspaceResultColumnProps {
  accentColor: string;
  hasActiveFilter: boolean;
  filterSignature: string;
  children: ReactNode;
}

export function InsightWorkspaceResultColumn({
  accentColor,
  hasActiveFilter,
  filterSignature,
  children,
}: InsightWorkspaceResultColumnProps) {
  return (
    <Box
      sx={{
        position: "relative",
        minWidth: 0,
        flex: 1,
        minHeight: 0,
        height: "100%",
        display: "flex",
      }}
    >
      <Paper
        key={filterSignature}
        elevation={0}
        sx={{
          borderRadius: 2,
          bgcolor: "background.paper",
          border: "1px solid",
          borderColor: "divider",
          borderLeftWidth: hasActiveFilter ? RESULT_SURFACE_BORDER : 1,
          borderLeftStyle: "solid",
          borderLeftColor: hasActiveFilter ? accentColor : "divider",
          animation: "insightResultFlash 0.6s ease-out",
          flex: 1,
          minHeight: 0,
          minWidth: 0,
          display: "flex",
          flexDirection: "column",
          width: "100%",
          overflow: "hidden",
          "@keyframes insightResultFlash": {
            from: { backgroundColor: alpha(accentColor, HIGHLIGHT_FLASH_ALPHA) },
            to: { backgroundColor: "background.paper" },
          },
        }}
      >
        <InsightPanelScrollBox accentColor={accentColor}>{children}</InsightPanelScrollBox>
      </Paper>
    </Box>
  );
}
